import { SettingsCategory } from '../enums'
import type { SettingsNavCategory } from '../types'

export function applyWorkspaceNavDisabledState(
  items: SettingsNavCategory[],
  hasWorkspace: boolean
): SettingsNavCategory[] {
  if (hasWorkspace) return items
  return items.map((category) => {
    if (category.id !== SettingsCategory.WORKSPACE) return category
    return {
      ...category,
      items: category.items.map((item) => ({ ...item, disabled: true })),
    }
  })
}
